import { Button, Grid, Typography } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { SearchParams } from "schemas/dashboard";
import { routes } from "schemas/routes";

import StyledOnboardingPage from "features/Auth/Onboarding/StyledOnboardingPage";
import {
  INSTAGRAM_ONBOARDING_CHOICE,
  INSTAGRAM_ONBOARDING_FLOW,
} from "utils/localStorage";
import { trackEvent } from "utils/tracking";

import { InstagramOnboardingOptions } from "../schema";
import styles from "./styles";

interface Props {
  handleCheckoutVa: () => void;
}

const StandardPreferenceQuestion = ({ handleCheckoutVa }: Props) => {
  const { currentOrg } = useContext(OrganizationUserContext);
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const handleNext = (option: InstagramOnboardingOptions) => {
    trackEvent("Onboarding Form - Next Button Pressed", {
      page: "preferencePage",
      route: location.pathname,
      option,
      "Social Onboarding Flow Type": localStorage.getItem(
        INSTAGRAM_ONBOARDING_FLOW,
      ),
    });
    localStorage.setItem(INSTAGRAM_ONBOARDING_CHOICE, option);
    searchParams.set(SearchParams.OPTION, option);
    setSearchParams(searchParams);
    const updatedParamsString = searchParams.toString();
    if (
      currentOrg?.id &&
      option === InstagramOnboardingOptions.done_for_you &&
      !currentOrg?.isVaUser
    ) {
      handleCheckoutVa();
    } else {
      navigate(`/${routes.aboutOnboarding}?${updatedParamsString}`);
    }
  };

  const handleBack = () => {
    trackEvent("Onboarding Form - Back Button Pressed", {
      page: "preferencePage",
      route: location.pathname,
    });
    navigate(`/${routes.aboutOnboarding}${location.search}`);
  };

  return (
    <>
      <StyledOnboardingPage
        title="Prefer to pitch brands yourself or have Bento do it for you?"
        handleBack={handleBack}
      >
        <Grid container justifyContent={"center"} gap={2} sx={{ mb: 3 }}>
          <Grid
            item
            xs={12}
            md={6}
            container
            sx={[styles.card, { backgroundColor: "white" }]}
          >
            <Grid item>
              <Typography variant="h6" textAlign={"left"}>
                Do it myself
              </Typography>

              <Typography textAlign={"left"} sx={{ mb: 2 }}>
                Use our advanced tools to pitch brands on your own
              </Typography>
            </Grid>

            <Grid item>
              <Button
                fullWidth
                variant="contained"
                disableElevation
                sx={{ borderRadius: 4 }}
                size="small"
                onClick={() =>
                  handleNext(InstagramOnboardingOptions.do_it_myself)
                }
              >
                Select
              </Button>
            </Grid>
          </Grid>

          <Grid
            item
            xs
            md
            container
            sx={[styles.card, { backgroundColor: "purple.main" }]}
          >
            <Grid item>
              <Typography variant="h6" textAlign={"left"}>
                Done for you 🚀{" "}
              </Typography>

              <Typography variant="caption" gutterBottom paragraph>
                <em>starts from $50.00/month</em>
              </Typography>

              <Typography textAlign={"left"} sx={{ mb: 2 }}>
                Set your goals, niche, and guardrails; Bento does the rest. It
                finds best-fit brands, sends relevant pitches, and schedules
                follow-ups.
              </Typography>
            </Grid>

            <Button
              fullWidth
              variant="contained"
              disableElevation
              sx={{ borderRadius: 4 }}
              size="small"
              onClick={() =>
                handleNext(InstagramOnboardingOptions.done_for_you)
              }
            >
              Select
            </Button>
          </Grid>
        </Grid>
      </StyledOnboardingPage>
    </>
  );
};

export default StandardPreferenceQuestion;
